
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
Toast
},
data() {
return {
show: false, // 是否显示
type: '', // 显示类型,默认为success warn，cancel, text,
time: 3000, // 显示时间
text: '', // 文字
width: '7.6em'
}
}
}



// WEBPACK FOOTER //
// ./src/components/Toast.vue